import React, { useState } from "react";
import "./GiveGuestAddPermission.css";

export default function GiveGuestAddPermission({
    isOpen,
    onClose,
    onInvite,
    openGivePermission,
    data
}) {
    const [maleGuest, setMaleGuest] = useState("");
    const [femaleGuest, setFemaleGuest] = useState("");
    const [guestCount, setGuestCount] = useState(0);

    if (!isOpen) return null;

    // ✅ total already added
    const totalBookedSlotsMale = data?.guest_list?.filter(
        (g) => g.guest_gender === "male"
    ).length;

    const totalBookedSlotsFemale = data?.guest_list?.filter(
        (g) => g.guest_gender === "female"
    ).length;

    // ✅ available slots (from booking)
    const availableSlotsMale = Math.max(
        (parseInt(data?.male) || 0) - totalBookedSlotsMale,
        0
    );

    const availableSlotsFemale = Math.max(
        (parseInt(data?.female) || 0) - totalBookedSlotsFemale,
        0
    );

    const handleInvite = () => {
        const total =
            (maleGuest ? parseInt(maleGuest) : 0) +
            (femaleGuest ? parseInt(femaleGuest) : 0);

        setGuestCount(total);

        if (onInvite) {
            onInvite({
                male: maleGuest,
                female: femaleGuest,
                total,
                givenTo: openGivePermission.id
            });
        }

        setMaleGuest("");
        setFemaleGuest("");

    };

    // ✅ Utility to render dropdown options dynamically
    const renderOptions = (limit) => {
        let opts = [];
        for (let i = 1; i <= limit; i++) {
            opts.push(
                <option key={i} value={i}>
                    {i}
                </option>
            );
        }
        return opts;
    };

    return (
        <div className="gap-overlay">
            <div className="gap-modal">
                {/* Header */}
                <div className="gap-header">
                    <h3>
                        Give Permission to <strong>{openGivePermission?.guest_name}</strong>{" "}
                        to Add Members
                    </h3>
                    <button className="gap-close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>

                {/* Dropdowns */}
                <div className="gap-body">
                    <div className="gap-row">
                        <label>Male Guest *</label>
                        <select
                            value={maleGuest}
                            onChange={(e) => setMaleGuest(e.target.value)}
                            disabled={availableSlotsMale === 0}
                        >
                            <option value="">Choose</option>
                            {renderOptions(availableSlotsMale)}
                        </select>
                        <small>{availableSlotsMale} slots left</small>
                    </div>

                    <div className="gap-row">
                        <label>Female Guest *</label>
                        <select
                            value={femaleGuest}
                            onChange={(e) => setFemaleGuest(e.target.value)}
                            disabled={availableSlotsFemale === 0}
                        >
                            <option value="">Choose</option>
                            {renderOptions(availableSlotsFemale)}
                        </select>
                        <small>{availableSlotsFemale} slots left</small>
                    </div>

                    <div className="gap-counter">{guestCount} Guest Added</div>
                </div>

                {/* Footer */}
                <div className="gap-footer">
                    <button 
                        className={
                            ((!maleGuest && !femaleGuest) ||
                                (parseInt(maleGuest) || 0) > availableSlotsMale ||
                                (parseInt(femaleGuest) || 0) > availableSlotsFemale)
                                ? "gap-btn-disabled"
                                : "gap-invite-btn"
                        }
                        onClick={handleInvite}
                        disabled={
                            (!maleGuest && !femaleGuest) ||
                            (parseInt(maleGuest) || 0) > availableSlotsMale ||
                            (parseInt(femaleGuest) || 0) > availableSlotsFemale
                        }
                    >
                        Invite
                    </button>

                </div>
            </div>
        </div>
    );
}
